import { axiosClient } from './request';

const driverServices = {
  list({
    pageSize = 20,
    pageIndex = 0,
    globalFilter = '',
    fleet_id,
    company_id,
    group_id,
    sort_by,
    moreFilterData = {}
  } = {}) {
    return axiosClient.get('/drivers', {
      params: {
        fleet_id,
        company_id,
        group_id,
        sort_by,
        limit: pageSize,
        page: pageIndex + 1,
        search: globalFilter,
        ...moreFilterData
      }
    });
  },
  create(body) {
    return axiosClient.post('/drivers', body);
  },
  detail({ driver_id, ...rest }) {
    return axiosClient.get(`/drivers/${driver_id}`, {
      params: rest
    });
  },
  updateDriver(id, body) {
    return axiosClient.put(`/drivers/${id}`, body);
  },
  listDriverInstantPayoutType() {
    return axiosClient.get(`/drivers/instant-payout-types`);
  },
  // Each market is a separate Stripe platform account, so the region header decides both which
  // account session is issued and which publishable key comes back with it.
  getTerminalHardwareAccountSession(region) {
    return axiosClient.get('/drivers/terminal-hardware/account-sessions', {
      headers: {
        'x-region': region || ''
      }
    });
  },
  // Label and registration code are all the client knows: the endpoint resolves the Stripe account
  // and the terminal location from the caller's own payment point. The region header picks the market
  // whose platform account ends up owning the reader.
  registerTerminalReader(region, body) {
    return axiosClient.post('/drivers/terminal-readers', body, {
      headers: {
        'x-region': region || ''
      }
    });
  }
};

export default driverServices;
